import { render, staticRenderFns } from "./OfficialHolidaysPlanNameTable.vue?vue&type=template&id=ba194c58&"
import script from "./OfficialHolidaysPlanNameTable.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports